import t, { Component as e } from "react";
import o from "../../../../node_modules/classnames/index.js";
import n from "../../../utils/DomHandler.js";
import r from "../../../utils/ObjectUtils.js";
function i(t) {
  if (void 0 === t) throw ReferenceError("this hasn't been initialised - super() hasn't been called");
  return t;
}
function l(t, e) {
  for (var o = 0; o < e.length; o++) {
    var n = e[o];
    n.enumerable = n.enumerable || !1, n.configurable = !0, "value" in n && (n.writable = !0), Object.defineProperty(t, n.key, n);
  }
}
function u(t, e, o) {
  return e in t ? Object.defineProperty(t, e, {
    value: o,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : t[e] = o, t;
}
function s(t) {
  return (s = Object.setPrototypeOf ? Object.getPrototypeOf : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  })(t);
}
function c(t, e) {
  return (c = Object.setPrototypeOf || function (t, e) {
    return t.__proto__ = e, t;
  })(t, e);
}
var a = function (e) {
  !function (t, e) {
    if ("function" != typeof e && null !== e) throw TypeError("Super expression must either be null or a function");
    t.prototype = Object.create(e && e.prototype, {
      constructor: {
        value: t,
        writable: !0,
        configurable: !0
      }
    }), e && c(t, e);
  }(h, e);
  var a,
    p,
    f,
    y = (a = function () {
      if ("undefined" == typeof Reflect || !Reflect.construct || Reflect.construct.sham) return !1;
      if ("function" == typeof Proxy) return !0;
      try {
        return Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})), !0;
      } catch (t) {
        return !1;
      }
    }(), function () {
      var t,
        e,
        o = s(h);
      if (a) {
        var n = s(this).constructor;
        e = Reflect.construct(o, arguments, n);
      } else e = o.apply(this, arguments);
      return (t = e) && ("object" == (t && "undefined" != typeof Symbol && t.constructor === Symbol ? "symbol" : typeof t) || "function" == typeof t) ? t : i(this);
    });
  function h() {
    var t;
    return !function (t, e) {
      if (!(t instanceof e)) throw TypeError("Cannot call a class as a function");
    }(this, h), t = y.apply(this, arguments), u(i(t), "el", void 0), u(i(t), "state", {
      styleObject: {}
    }), t;
  }
  return p = [{
    key: "getColumnProp",
    value: function value(t) {
      return this.props.column.props[t];
    }
  }, {
    key: "getStyle",
    value: function value() {
      var t = this.getColumnProp("footerStyle"),
        e = this.getColumnProp("style");
      return this.getColumnProp("frozen") ? Object.assign({}, e, t, this.state.styleObject) : Object.assign({}, e, t);
    }
  }, {
    key: "updateStickyPosition",
    value: function value() {
      if (this.getColumnProp("frozen")) {
        var t = function (t) {
          for (var e = 1; e < arguments.length; e++) {
            var o = null != arguments[e] ? arguments[e] : {},
              n = Object.keys(o);
            "function" == typeof Object.getOwnPropertySymbols && (n = n.concat(Object.getOwnPropertySymbols(o).filter(function (t) {
              return Object.getOwnPropertyDescriptor(o, t).enumerable;
            }))), n.forEach(function (e) {
              u(t, e, o[e]);
            });
          }
          return t;
        }({}, this.state.styleObject);
        if ("right" === this.getColumnProp("alignFrozen")) {
          var e = 0,
            o = this.el.nextElementSibling;
          o && (e = n.getOuterWidth(o) + parseFloat(o.style.right || 0)), t.right = e + "px";
        } else {
          var r,
            i = 0,
            l = null === (r = this.el) || void 0 === r ? void 0 : r.previousElementSibling;
          l && (i = n.getOuterWidth(l) + parseFloat(l.style.left || 0)), t.left = i + "px";
        }
        this.setState({
          styleObject: t
        });
      }
    }
  }, {
    key: "componentDidMount",
    value: function value() {
      this.getColumnProp("frozen") && this.updateStickyPosition();
    }
  }, {
    key: "componentDidUpdate",
    value: function value(t, e) {
      this.getColumnProp("frozen") && !r.deepEquals(e.styleObject, this.state.styleObject) && this.updateStickyPosition();
    }
  }, {
    key: "render",
    value: function value() {
      var e = this,
        n = this.getStyle(),
        i = o("datatable__cell datatable__cell--foot", this.getColumnProp("footerClassName"), this.getColumnProp("className"), {
          "datatable__column--frozen": this.getColumnProp("frozen")
        }),
        l = this.getColumnProp("colSpan") ? parseInt(this.getColumnProp("colSpan")) : 0,
        u = this.getColumnProp("rowSpan") ? parseInt(this.getColumnProp("rowSpan")) : 0,
        s = r.getJSXElement(this.getColumnProp("footer"), {
          props: this.props.tableProps
        });
      return t.createElement("td", {
        ref: function ref(t) {
          return e.el = t;
        },
        style: n,
        className: i,
        role: "cell",
        colSpan: l,
        rowSpan: u
      }, s);
    }
  }], l(h.prototype, p), f && l(h, f), h;
}(e);
export { a as FooterCell };